// extracted by mini-css-extract-plugin
module.exports = {"container":"ReadingPreferenceSwitcher_container__0Dzn6"};